import { existsSync } from 'node:fs';
import { InvalidArgumentError } from '@commander-js/extra-typings';

export function validateDirectoryExists(path: string) {
  if (!existsSync(path)) {
    throw new InvalidArgumentError('Directory does not exist.');
  }

  return path;
}
